export function isStandalonePwa(): boolean {
  return window.matchMedia("(display-mode: standalone)").matches
    || window.matchMedia("(display-mode: fullscreen)").matches
    || (navigator as Navigator & { standalone?: boolean }).standalone === true;
}

export function setupPwaInstallHint(): void {
  const hint = document.querySelector<HTMLElement>("#pwa-install-hint");
  const dismiss = document.querySelector<HTMLButtonElement>("#pwa-install-dismiss");
  if (!hint || !dismiss) return;

  // Platform detection only selects installation instructions; layout uses CSS.
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  let dismissed = false;
  const refresh = (): void => { hint.hidden = dismissed || !ios || isStandalonePwa(); };
  dismiss.addEventListener("click", () => { dismissed = true; refresh(); });
  window.matchMedia("(display-mode: standalone)").addEventListener("change", refresh);
  window.matchMedia("(display-mode: fullscreen)").addEventListener("change", refresh);
  window.addEventListener("pageshow", refresh);
  refresh();
}
